import { priorityInboxThreadInvalidations } from "@circle-react/lib/queries/priorityInboxThreads";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

import { useUnreadChatThreads } from "../useUnreadChatThreads";

export const useMarkAllChatThreadsAsRead = () => {
  const toast = useToast();
  const { resetNewBadgeIds } = useUnreadChatThreads();
  const { mutateAsync: markAllChatThreadsAsRead, isPending: isLoading } =
    useMutation({
      mutationFn: () =>
        reactQueryPatch(internalApi.chatThreads.markAllAsRead()),
      onSuccess: () => {
        resetNewBadgeIds();
        void priorityInboxThreadInvalidations.all();
        toast.success(t("header_v3.chat_threads_marked_as_read"));
      },
    });

  return { markAllChatThreadsAsRead, isLoading };
};
